import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import Creatable from "react-select/creatable";

const SelectField = props => {
    const styles = (err) => {
        const borderStyle = (isFocused, err) => {
            let attributes = {
                boxShadow: isFocused ? "0 0 0 1px #003DA5" : "none"
            };

            if (isFocused)
                attributes.borderColor = "#003DA5";

            attributes["&:hover"] = { ...attributes };

            if (err && !isFocused)
                attributes.borderColor = "red";

            return attributes;
        };

        return {
            control: (base, state) => ({
                ...base,
                ...borderStyle(state.isFocused, err)
            })
        };
    };

    return props.type === "creatable" ? (
        <Creatable
            { ...props }
            styles={{
                ...props.styles,
                ...styles(props.error)
            }}
        />
    ) : (
        <Select
            { ...props }
            styles={{
                ...props.styles,
                ...styles(props.error)
            }}
        />
    );
};

SelectField.propTypes = {
    type: PropTypes.string,
    error: PropTypes.bool,
};

export default SelectField;
